<template>
  <el-dialog
    title="Add comment"
    :visible.sync="formModalOpened"
    :before-close="handleClose"
    v-if="formModalContext"
  >

    <comment-form ref="form" :id="formModalContext.id" :type="formModalContext.type" :showButton="false" :onSubmit="handleFormSubmit" />

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleClickSubmit" :loading="processing">{{ buttonText }}</el-button>
      <el-button @click="handleClose">Close</el-button>
    </span>

  </el-dialog>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  import CommentForm from '@/components/comment/CommentForm';

  export default {
    name: 'CommentFormModal',
    components: {
      commentForm: CommentForm,
    },
    props: {
      action: {
        type: Function,
        required: true,
      },
    },
    data() {
      return {
        processing: false,
      };
    },
    computed: {
      ...mapGetters('entities/comments', ['creating', 'formModalContext']),

      formModalOpened: {
        get() {
          return this.$store.getters['entities/comments/formModalOpened'];
        },
        set(newValue) {
          if (!newValue) {
            this.handleClose();
          }
        },
      },

      buttonText() {
        return this.formModalContext.buttonText || 'Submit';
      },
    },
    methods: {
      ...mapActions('entities/comments', ['closeFormModal']),

      handleClickSubmit() {
        this.$refs.form.submitForm();
      },

      handleFormSubmit(commentData) {
        this.action(this.formModalContext.command, { ...commentData, label: this.formModalContext.label });
      },

      handleClose() {
        this.closeFormModal();
      },

    },
  };
</script>



// WEBPACK FOOTER //
// src/components/comment/CommentFormModal.vue